import React from 'react';
import BlockIcon from '@material-ui/icons/Block';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import { useForm } from "react-hook-form";
import { useRef, useState } from "react";
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import toast from 'react-hot-toast';
import { ToastNotify } from '../../ShearCompo/ToastNotify/ToastNotify';


export const ManageUserAddUserFrom = () => {
    const { register, handleSubmit, watch, formState: { errors } } = useForm();
    const password = useRef({});
    password.current = watch("password", "");

    const onSubmit = (e) => {

        if (e) {
            toast.success("User is added successfully!");
            // toast.successUndo("Group is edited successfully!");
        } else {
            toast.error("Something went wrong, please try again!")
        }
    }
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0');
    let yyyy = today.getFullYear();
    today = mm + '/' + dd + '/' + yyyy
    let [showPass, setShowPass] = useState(false)
    let handleShowPass = () => {
        setShowPass(!showPass)
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
                <h5>Information</h5>
                <div className="co-lg-6 col-md-6">
                    <h6>Name</h6>
                    <input className=" form-control "   {...register("name", { required: true })} />
                    <small className="mb-2 text-muted"> User Name,shwon in the profile</small><br />
                    {errors.name && <span className="text-danger">This field is required</span>}

                    <h6 >Login ID</h6>

                    <input className="form-control"  {...register("loginID", { required: true })} />
                    <small className="mb-2 text-muted"> Login ID is used authentication in the web portal.</small><br />
                    {errors.loginID && <span className="text-danger">This field is required</span>}

                    <h6 >Email</h6>
                    <input className=" form-control " id="email" aria-invalid={errors.email ? "true" : "false"}{...register("email", { required: true, pattern: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/ })} />
                    <small className="mb-2 text-muted">Email is used for password reset, newsletter and verification.</small> <br />
                    {errors.email && errors.email.type === "required" && (
                        <span role="alert" className="text-danger">This is required</span>
                    )}
                    {errors.email && errors.email.type === "pattern" && (
                        <span role="alert" className="text-danger">Please enter valid email</span>
                    )}


                    <h6 >Last Used IP</h6>
                    <input className=" form-control "   {...register("lastUsedIP", { required: true })} />
                    <small className="mb-2 text-muted">Last IP used by the user to login the website</small>


                    <h6 >Password</h6>
                    <div className="input-icons">
                        <span onClick={handleShowPass}> {showPass ? <VisibilityIcon className="seePass" /> : < VisibilityOffIcon className="seePass" />} </span>
                        <input className=" form-control " id="password" type={showPass ? "text" : "password"}  {...register("password", {
                            required: "You must specify a password",
                            minLength: {
                                value: 8,
                                message: "Password must have at least 8 characters"
                            }
                        })} />

                        <small className="mb-2 text-muted">Password must contain #@5643!</small><br />
                        {errors.password && <p className="text-danger">{errors.password.message}</p>}

                    </div>



                </div>
                <div className="co-lg-6 col-md-6">



                    <h6 >Mobile</h6>
                    <input id="mobile" aria-invalid={errors.mobile ? "true" : "false"} className=" form-control " type="number" {...register("mobile", { required: true, maxLength: 11, minLength: 11 })} />
                    <small className="mb-2 text-muted">used for password reset , SMS offers and verification</small> <br />
                    {errors.mobile && errors.mobile.type === "required" && (
                        <span role="alert" className="text-danger">This is required</span>
                    )}
                    {errors.mobile && errors.mobile.type === "maxLength" && (
                        <span role="alert" className="text-danger">Max length exceeded</span>
                    )}

                    <h6 >Group</h6>

                    <input className=" form-control"    {...register("group", { required: true })} />
                    <small className="mb-2 text-muted">Group is assigned to user to have certian responsibility</small><br />
                    {errors.group && <span className="text-danger">This field is required</span>}

                    <h6 >Role</h6>
                    <input className="  form-control"   {...register("role", { required: true })} />
                    <small className="mb-2 text-muted">Role is assigned to user control the access to different pages</small><br />
                    {errors.role && <span className="text-danger">This field is required</span>}
                    <h6 >Creation Date</h6>

                    <input className="form-control " defaultValue={today} disabled  {...register("creationDate")} />
                    <small className="mb-2 text-muted">The user was created on the following date</small> <br />

                    <h6 > Confirm Password</h6>
                    <div className="input-icons">
                        <span onClick={handleShowPass}> {showPass ? <VisibilityIcon className="seePass" /> : < VisibilityOffIcon className="seePass" />} </span>
                        <input className="form-control " type={showPass ? "text" : "password"} id="confirmPassword"  {...register("confirmPassword", {
                            validate: value => value === password.current || "The passwords do not match"
                        })} />

                        <small className="mb-2 text-muted">Retype your Password </small> <br />
                        {errors.confirmPassword && <p className="text-danger">{errors.confirmPassword.message}</p>}
                    </div>
                </div>
            </div>
            <div className="dataTableSubmitBtn">
                <input className="btn btn-success" value="Save" type="submit" />
            </div>
            <ToastNotify />
        </form>
    );
};

export const ManageUserEditDetailsFrom = ({ userDetails, which }) => {

    const { register, handleSubmit, formState: { errors } } = useForm();
    const [getUndo, setUndo] = useState(false);


    const onSubmit = (data) => {
        if (!data) {
            toast.success("User is edited successfully!");
            setUndo(true)
        } else {
            toast.error("Something went wrong, please try again!")
            setUndo(false)
        }
    }

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                    <h5>Information</h5>
                    <div className="co-lg-6 col-md-6">
                        <h6>Name</h6>
                        <input className="form-control " disabled={which ? false : true} defaultValue={userDetails?.name}   {...register("name", { required: true })} />
                        <small className="mb-2 text-muted">{which ? 'User Name,shwon in the profile' : 'disabled Field'}</small><br />
                        {errors.name && <span className="text-danger">This field is required</span>}

                        <h6 >Login ID</h6>

                        <input className="form-control " disabled={which ? false : true} defaultValue={userDetails?.loginID}   {...register("loginID", { required: true })} />


                        <small className="mb-2 text-muted">{which ? 'Login ID is used authentication in the web portal.' : 'disabled Field'}</small><br />
                        {errors.loginID && <span className="text-danger">This field is required</span>}
                        <h6 >Email</h6>
                        <input className="form-control " disabled={which ? false : true} defaultValue={userDetails?.email}   {...register("email", { required: true })} />

                        <small className="mb-2 text-muted">{which ? 'Email is used for password reset, newsletter and verification.' : 'disabled Field'}</small> <br />

                        {errors.email && <span className="text-danger">This field is required</span>}
                        <h6 >Last Used IP</h6>
                        <input className="form-control " disabled={which ? false : true} defaultValue="43.988.5.45"  {...register("lastUsedIP", { required: true })} />
                        <small className="mb-2 text-muted">{which ? 'Last IP used by the user to login the website' : 'disabled Field'}</small>


                    </div>
                    <div className="co-lg-6 col-md-6">
                        <h6 >Mobile</h6>
                        <input className=" form-control" disabled={which ? false : true} defaultValue={userDetails?.mobile}   {...register("mobile", { required: true })} />
                        <small className=" text-muted">{which ? 'used for password reset , SMS offers and verification' : 'disabled Field'}</small> <br />
                        {errors.mobile && <span className="text-danger">This field is required</span>}
                        <h6 >Group</h6>

                        <input className=" form-control " disabled={which ? false : true} defaultValue={userDetails?.group}   {...register("group", { required: true })} />
                        <small className="mb-2 text-muted">{which ? 'Group is assigned to user to have certian responsibility.' : 'disabled Field'}</small><br />
                        {errors.group && <span className="text-danger">This field is required</span>}

                        <h6 >Role</h6>
                        <input className="form-control form-control" disabled={which ? false : true} defaultValue={userDetails?.role}   {...register("role", { required: true })} />
                        <small className="mb-2 text-muted">{which ? 'Role is assigned to user control the access to different pages' : 'disabled Field'}</small><br />
                        {errors.role && <span className="text-danger">This field is required</span>}
                        <h6 >Creation Date</h6>

                        <input className="form-control form-control " disabled={which ? false : true} defaultValue={userDetails?.creationDate}   {...register("creationDate", { required: true })} />
                        <small className="mb-2 text-muted">{which ? 'The user was created on the following date' : 'disabled Field'}</small> <br />
                        {errors.creationDate && <span className="text-danger">This field is required</span>}

                    </div>
                    {which ? <>
                        <h5>Actions</h5>
                        <div className=" ">
                            <button className="resetPass  modalBtn "> <VpnKeyIcon className="ban" />  Reset Password</button>
                            <button className=" banUser modalBtn"><BlockIcon className="ban" />  Ban the user</button>
                        </div>
                    </> : " "}
                </div>
                <div className="dataTableSubmitBtn">
                    {which ? <input className="btn btn-success" value="Save" type="submit" /> : ""}
                    {/*  onClick={() => notify()} */}
                </div>
                <ToastNotify undoFunction={getUndo} />
            </form>
        </>
    );
};

